'use client';

import BaseModal from '@c/modals/BaseModal';
import SafeImage from '@ui/SafeImage';
import { prefix } from '@util/imagePrefix';
import { Montserrat } from 'next/font/google';

const montserrat = Montserrat({
  subsets: ['latin'],
  weight: ['400', '500', '600', '700'],
});

interface FreeEntryModalProps {
  isOpen: boolean;
  dismiss: () => void;
}

export default function FreeEntryModal({
  isOpen,
  dismiss,
}: FreeEntryModalProps) {
  return (
    <BaseModal isOpen={isOpen} dismiss={dismiss} hideCloseIcon>
      <div className={`w-[90vw] max-w-[50rem] ${montserrat.className}`}>
        <div className="relative">
          <SafeImage
            src={`${prefix}/assets/adolf-silva-giveaway/modal-header_1920x2560.png`}
            alt="Free Entry"
            className="h-[28rem] w-full rounded-t-[3rem] object-cover"
            width={1920}
            height={2560}
          />

          <button
            type="button"
            onClick={dismiss}
            className="absolute right-4 top-4 flex h-14 w-14 items-center justify-center rounded-full bg-white"
          >
            <span className="text-[2rem] font-bold text-black">✕</span>
          </button>
        </div>

        <div className="flex flex-col gap-6 p-12">
          <h3 className="text-[3rem] font-bold tracking-tight">
            Free Entry Instructions
          </h3>

          <p className="text-[1.8rem] font-bold text-[#C41719]">
            No purchase necessary.
          </p>

          <div className="flex flex-col gap-4 text-[1.6rem] text-[#444444]">
            <p>
              To enter without donating, hand-print your full name, address,
              email address, and date of birth on a 3&quot;x5&quot; postcard and
              mail it to:
              <br />
              <strong>
                MX Locker - Yeti Bike Giveaway
                <br />
                38415 Innovation Court
                <br />
                SUITE E
                <br />
                Murrieta, CA 92563
              </strong>
            </p>

            <p>
              One postcard per outer envelope. Entries must be postmarked by May
              13 and received by May 19. Free entries receive one (1)
              sweepstakes entry, equal to one paid entry.
            </p>
          </div>
        </div>
      </div>
    </BaseModal>
  );
}
